export { ZapierLogo } from './ZapierLogo';
